export default "__VITE_ASSET__Dsb_28PN__"